export default function ToNumArrayFilter(moduleName) {
    angular.module(moduleName || 'app')
        .filter('toNumArray', toNumArray);

    toNumArray.$inject = ['$sce'];
    function toNumArray($sce) {
        return function (val, start) {
            if (isNaN(val)) {
                return [];
            }
            if (start === undefined) {
                start = 1;
            }
            var result = [];
            for (var i = start; i <= val; i++) {
                result.push(i);
            }
            return result;
        };
    }
} 